import axios from "axios";

/**
 * Makes a GET request to endpoint.
 * @param {string} endpoint
 * @param {number[]} [expectedStatusCodes=[]]
 * @returns {Promise}
 */
export const get = (endpoint, expectedStatusCodes = []) => {
  return new Promise((resolve, reject) => {
    axios
      .get(endpoint)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (expectedStatusCodes.includes(error.response?.status)) {
          resolve(error);
        } else {
          console.error(error);
          reject(error);
        }
      });
  });
};

/**
 * Makes a POST request to endpoint.
 * @param {string} endpoint
 * @param {Object} requestBody
 * @param {number[]} [expectedStatusCodes=[]]
 * @returns {Promise}
 */
export const post = (endpoint, requestBody, expectedStatusCodes = []) => {
  return new Promise((resolve, reject) => {
    axios
      .post(endpoint, requestBody)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (expectedStatusCodes.includes(error.response?.status)) {
          resolve(error);
        } else {
          console.error(error);
          reject(error);
        }
      });
  });
};

/**
 * Makes a DELETE request to endpoint
 * @param {string} endpoint
 * @param {number[]} [expectedStatusCodes=[]]
 * @returns {Promise}
 */
export const deleteReq = (endpoint, expectedStatusCodes = []) => {
  return new Promise((resolve, reject) => {
    axios
      .delete(endpoint)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (expectedStatusCodes.includes(error.response?.status)) {
          resolve(error);
        } else {
          console.error(error);
          reject(error);
        }
      });
  });
};

/**
 * NOTE: USE GET UNLESS CALLBACKS ARE SPECIFICALLY NEEDED
 *
 * Makes a GET request to endpoint.
 * - When successful, call given success function with data.
 * - When unsuccessful, print error and call given error function.
 * @param {string} endpoint
 * @param {function} success function called after successful request
 * @param {function} error function called after error
 * @param {number[]} [expectedStatusCodes=[]]
 */
export const getCallback = (endpoint, success, error = () => {}, expectedStatusCodes = []) => {
  axios
    .get(endpoint)
    .then((response) => {
      success(response);
    })
    .catch((err) => {
      if (expectedStatusCodes.includes(err.response?.status)) {
        success(err);
      } else {
        console.error(err);
        error(err);
      }
    });
};

/**
 * NOTE: USE GET UNLESS CALLBACKS ARE SPECIFICALLY NEEDED
 *
 * Makes a POST request to endpoint.
 * - When successful, call given success function with data.
 * - When unsuccessful, print error and call given error function.
 * @param {string} endpoint
 * @param {Object} requestBody
 * @param {function} success Function called after successful request
 * @param {function} error Function called after error
 * @param {number[]} [expectedStatusCodes=[]]
 */
export const postCallback = (endpoint, requestBody, success = () => {}, error = () => {}, expectedStatusCodes = []) => {
  axios
    .post(endpoint, requestBody)
    .then((response) => {
      success(response);
    })
    .catch((err) => {
      if (expectedStatusCodes.includes(err.response?.status)) {
        success(err);
      } else {
        console.error(err);
        error(err);
      }
    });
};
